<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('payment_terms.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openPaymentTermForm"
                            ></bc-btn-add>
                            <bc-btn-refresh
                                @invoke-method="dbGetPaymentTerms(true)"
                            ></bc-btn-refresh>
                            <bc-search-menu
                                :params="axiosParams"
                            >
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="payment_terms"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openPaymentTermForm(props.item)">
								<td>{{ props.item.term_days }}</td>
								<td>{{ props.item.description }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination
                        :page="page"
                        :params="axiosParams"
                        name="payment_terms"
                    ></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="payment_term_dialog">
                <v-card>
                    <v-form ref="form_payment_term">
                        <v-card-title>
                            <span class="headline">{{ payment_term.payment_term_id ? $t('lang.edit_payment_term') : $t('lang.add_payment_term') }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closePaymentTermDialog"
                                :dialog-status="payment_term_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
							<v-flex xs12>
								<v-text-field
									v-focus="payment_term_dialog"
									v-model="payment_term.term_days"
									:label="`${$t('lang.term_days')} *`"
									:counter="showCounter(payment_term.term_days, 'payment_terms.term_days')"
									:rules="ifValid('payment_terms.term_days')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="payment_term.description"
									:label="`${$t('lang.description')} *`"
									auto-grow
									rows="1"
									:rules="ifValid('payment_terms.description')"
								></v-textarea>
							</v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="payment_term.payment_term_id" color="error" @mouseup.left="$refs.delete_payment_terms.openDialog()">{{ $t('lang.delete') }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closePaymentTermDialog()">{{$t('lang.cancel')}}</v-btn>
                            <v-btn color="success" @click="savePaymentTerms">{{$t('lang.save')}}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_payment_terms"
                :heading="$t('lang.delete_payment_term')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deletePaymentTerms(payment_term.payment_term_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openPaymentTermForm" },
                { title: this.$t("lang.refresh"), action: "dbGetPaymentTerms", params: [true] },
            ],
            headers: [{ text: this.$t("lang.term_days"), sortable: false, width: "50%" }, { text: this.$t("lang.description"), sortable: false, width: "50%" }],
            enableAddModal: true,
            enableEditModal: true,

            payment_term: {},
            filter: {
                search: "",
            },
            payment_term_dialog: false,
            dbGetPaymentTerms: _.debounce(this.getPaymentTerms, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchPaymentTerms", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.payment_terms) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchPaymentTerms({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.payment_terms) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.payment_terms.payment_terms_filter,
            page: (state) => state.payment_terms.page,
            rules_payment_terms: (state) => state.payment_terms.rules_payment_terms,
            payment_term_status_options: (state) => state.settings.payment_term_status_options,
            payment_terms: (state) => state.payment_terms.payment_terms,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchPaymentTerms", "savePaymentTerm", "deletePaymentTerm"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openPaymentTermForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_payment_term) item ? this.$refs.form_payment_term.resetValidation() : this.$refs.form_payment_term.reset();

                    this.$nextTick(() => {
                        this.payment_term = item != null ? this.assignObj2(item, this.rules_payment_terms) : {};
                        this.payment_term_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "payment_term", params: { id: item.payment_term_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_payment_term) item ? this.$refs.form_payment_term.resetValidation() : this.$refs.form_payment_term.reset();
                    this.payment_term_dialog = true;
                } else {
                    this.$router.push({ name: "payment_term" });
                }
            }
        },
        savePaymentTerms() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_payment_term")) {
                    let body = this.prepForm(this.payment_term, this.rules_payment_terms);

                    this.savePaymentTerm({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getPaymentTerms();
                                this.closePaymentTermDialog();
                            } else {
                                this.$router.push({ name: "payment_term", params: { id: data.payment_term_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deletePaymentTerms(id = null) {
            this.deletePaymentTerm({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getPaymentTerms();
                    this.closePaymentTermDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closePaymentTermDialog() {
            this.payment_term_dialog = false;
            this.$refs.delete_payment_terms.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getPaymentTerms(pg_refresh = false) {
            this.startLoader();

            this.fetchPaymentTerms({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.payment_term_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
    },
};
</script>
